import { MailboxInfo, MailboxType } from 'owa-client-ids';
import { getConnectedAccountHeaders } from './getConnectedAccountHeaders';
import { setHeaders, getRequestOptionsOrDefault } from 'owa-headers-core';
import { RequestOptions, HeadersWithoutIterator } from 'owa-service/lib/RequestOptions';

export async function getConnectedAccountRequestOptions(
    mailboxInfo: MailboxInfo
): Promise<RequestOptions> {
    const defaultRequestOptions = getRequestOptionsOrDefault(mailboxInfo);
    defaultRequestOptions.headers = await getHeadersForConnectedAccount(mailboxInfo);
    defaultRequestOptions.authNeededOnUnAuthorized = false;
    defaultRequestOptions.datapoint = defaultRequestOptions.datapoint || {};
    defaultRequestOptions.datapoint.mailbox = 'Connected';
    return defaultRequestOptions;
}

export async function getHeadersForConnectedAccount(
    mailboxInfo: MailboxInfo
): Promise<HeadersWithoutIterator> {
    const headers = new Headers();

    const connectedAccountHeaders = await getConnectedAccountHeaders(
        mailboxInfo.userIdentity,
        mailboxInfo.type == MailboxType.GroupMailbox || mailboxInfo.type == MailboxType.TeamsMailbox
            ? mailboxInfo.mailboxSmtpAddress
            : null
    );
    setHeaders(headers, connectedAccountHeaders);

    return headers;
}
